module.exports = __webpack_public_path__ + "img/cover-5.2444eb55.jpg";